import React, { FCC } from 'react';
import { ILabelProps } from './types';

/**
 * Automatically adds "(optional)"
 */
export const Label: FCC<ILabelProps> = (props) => {
  const isOptional = props.showOptional ? <span className={'optional'}>(optional)</span> : null;
  return (
    <label id={props.id} className={props.className} htmlFor={props.htmlFor}>
      {props.children} {isOptional}
    </label>
  );
};

export default Label;
